import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RequestListRoutingModule } from './request-list-routing.module';
import { RequestListCardComponent } from './request-list-card/request-list-card.component';
import { RequestListComponent } from './request-list.component';
import { SharedModule } from '@shared/shared.module';
import { MatDatepickerModule } from '@angular/material/datepicker';


@NgModule({
  declarations: [
    RequestListCardComponent,
    RequestListComponent
  ],
  imports: [
    CommonModule,
    RequestListRoutingModule,
    SharedModule,
    MatDatepickerModule,
  ]
})
export class RequestListModule { }
